'use client';

import { PropsWithChildren } from 'react';

import { PageLayout, type PageLayoutProps } from '@/app/components/layout';
import { useCobranded } from '@/app/contexts/CobrandedProvider';

import BusinessHeader from './BusinessHeader';

interface Props {
  readonly pageName: PageLayoutProps['pageName'];
}

const BusinessPageLayout = ({
  children,
  pageName,
}: PropsWithChildren<Props>) => {
  const { config } = useCobranded();

  const name = config
    ? `${config.displayName} Order Portal`
    : 'Business Order Portal';

  return (
    <PageLayout hideSocialLinks name={name} pageName={pageName}>
      <BusinessHeader />
      {children}
    </PageLayout>
  );
};

export default BusinessPageLayout;
